import React, { Component } from "react";
import Icon from "@alboompro/boom-components/general/icon";
import { I18n } from "react-redux-i18n";
import cx from "classnames";
import RangeInput from "../RangeInput";
import BorderExtended from "./TypeInputRadius/BorderExtended";
import InputRefHandlerRadius from "./InputsRefHandler/InputRefHandlerRadius";
import InputRefHandlerWidth from "./InputsRefHandler/InputRefHandlerWidth";
import ColorPicker from "../ColorPickerComponent";

import {
  PopoverWrapper,
  PropItem,
  RadiusChangeButton,
  IconWrapper,
  BoxButtons,
  PropHeader,
  PropLabel,
} from "./styles";

class BorderPopover extends Component {
  changeOptionsRadius = () => {
    const { currentValue, name, updaterFn } = this.props;
    const { lockedInputRadius, iconInputRadius, radius } = currentValue;

    let newRadius;
    if (lockedInputRadius) {
      newRadius = Math.min(...radius);
    } else {
      newRadius = [radius, radius, radius, radius];
    }

    updaterFn({
      prop: name,
      value: {
        ...currentValue,
        lockedInputRadius: !lockedInputRadius,
        radius: newRadius,
        iconInputRadius:
          iconInputRadius === "hyperlink-2.svg"
            ? "link-broken.svg"
            : "hyperlink-2.svg",
      },
    });
  };

  changeType = (type2) => {
    const { currentValue, name, updaterFn } = this.props;
    updaterFn({ prop: name, value: { ...currentValue, type: type2 } });
  };

  changeColor = (e) => {
    const { currentValue, name, updaterFn } = this.props;
    updaterFn({ prop: name, value: { ...currentValue, color: e.rgb } });
  };

  changeWidth = (e) => {
    const { currentValue, name, updaterFn } = this.props;
    updaterFn({
      prop: name,
      value: { ...currentValue, width: e.target.value },
    });
  };

  changeRadius = (e) => {
    const { currentValue, name, updaterFn } = this.props;
    updaterFn({
      prop: name,
      value: { ...currentValue, radius: e.target.value },
    });
  };

  render() {
    const { currentValue, widthOptions, radiusOptions } = this.props;
    const { width, color, type, iconInputRadius, lockedInputRadius, radius } =
      currentValue;

    const {
      min: minWidth,
      max: maxWidth,
      step: stepWidth,
    } = widthOptions || {};
    const {
      min: minRadius,
      max: maxRadius,
      step: stepRadius,
    } = radiusOptions || {};

    const colorActive = "#44ADF8";
    const colorDefault = "#494949";

      const SolidIconWrapperClasses = cx({
        active: type === "solid",
      });

      const DashedIconWrapperClasses = cx({
        active: type === "dashed",
      });

      const DottedIconWrapperClasses = cx({
        active: type === "dotted",
      });

    return (
      <PopoverWrapper>
        {radius !== undefined && (
          <PropItem column>
            <PropHeader>
              <PropLabel>{I18n.t("editPanel.border.rounding")}</PropLabel>
              <RadiusChangeButton onClick={this.changeOptionsRadius}>
                <Icon
                  kind="bold"
                  group="interface-essential"
                  category="link-unlink"
                  file={iconInputRadius}
                  size="15"
                  color={colorDefault}
                />
              </RadiusChangeButton>
              {!lockedInputRadius && <InputRefHandlerRadius {...this.props} />}
            </PropHeader>

            {lockedInputRadius ? (
              <BorderExtended {...this.props} />
            ) : (
              <RangeInput
                min={minRadius}
                max={maxRadius}
                step={stepRadius}
                value={radius}
                onChange={this.changeRadius}
              />
            )}
          </PropItem>
        )}

        {width !== undefined && (
          <PropItem column>
            <PropHeader style={{ justifyContent: "space-between" }}>
              <PropLabel>{I18n.t("editPanel.border.thickness")}</PropLabel>
              <InputRefHandlerWidth {...this.props} />
            </PropHeader>
            <RangeInput
              min={minWidth}
              max={maxWidth}
              step={stepWidth}
              value={width}
              onChange={this.changeWidth}
            />
          </PropItem>
        )}

        {color !== undefined && (
          <PropItem>
            <PropLabel>{I18n.t("editPanel.border.color")}</PropLabel>
            <ColorPicker
              color={!color ? currentValue : color}
              onChange={this.changeColor}
            />
          </PropItem>
        )}

        {type !== undefined && (
          <PropItem>
            <PropLabel>{I18n.t("editPanel.border.type")}</PropLabel>
            <BoxButtons>
              <IconWrapper
                type="button"
                active={type === "solid"}
                onClick={() => this.changeType("solid")}
                className={SolidIconWrapperClasses}
              >
                <Icon
                  kind="bold"
                  group="interface-essential"
                  category="remove-add"
                  file="subtract.svg"
                  size="20"
                  color={type === "solid" ? colorActive : colorDefault}
                />
              </IconWrapper>

              <IconWrapper
                type="button"
                active={type === "dashed"}
                onClick={() => this.changeType("dashed")}
                className={DashedIconWrapperClasses}
              >
                <Icon
                  kind="regular"
                  group="phones-mobile-devices"
                  category="signal"
                  file="signal-no.svg"
                  size="18"
                  color={type === "dashed" ? colorActive : colorDefault}
                />
              </IconWrapper>

              <IconWrapper
                type="button"
                active={type === "dotted"}
                onClick={() => this.changeType("dotted")}
                className={DottedIconWrapperClasses}
              >
                <Icon
                  kind="bold"
                  group="interface-essential"
                  category="menu"
                  file="navigation-menu-horizontal.svg"
                  size="20"
                  color={type === "dotted" ? colorActive : colorDefault}
                />
              </IconWrapper>
            </BoxButtons>
          </PropItem>
        )}
      </PopoverWrapper>
    );
  }
}
export default BorderPopover;
